var _e = function e(p) {
  return ["string", "number"].includes(typeof p) ? p : p instanceof Array ? p.map(_e).join("") : "object" == typeof p && p ? p.type && p.type.displayName && p.type.displayName.includes("Tooltip") ? "" : p.props.children || "function" != typeof p.type ? _e(p.props.children) : _e(p.type.prototype && p.type.prototype.render ? "StyledComponent" !== p.type.name ? function (e) {
    return new e.type(e.props).render();
  }(p) : "" : p.type(p.props).props.children) : void 0;
};
export { _e as default };